module.exports = __webpack_public_path__ + "static/media/services.de290b28.svg";